import getWin32StyleStore from "../store/win32StyleStore";

/**
 * Returns the live Win32 style value used by UI consumers.
 * This includes unsaved preview changes and defaults to disabled before hydration.
 *
 * @returns Whether Win32 styling is enabled
 */
export default function getWin32StyleEnabled(): boolean {
    return getWin32StyleStore().isEnabledPreview ?? false;
}
